import { useState } from 'react';

// Hook component to show "spinner" to the user when page is loading or backend services are executing
export const useisLoading = (initialState = false) => {
    
    // Variable to show/hide "spinner" while loading page.
    const [ isLoading, setisLoading ] = useState(initialState); // false by default.

    const reset = () => {
        setisLoading( initialState );
    }

    // Call this function before call a backend service or heavy process than spend to much time for user wait.
    const showSpinner = () => {
        setisLoading( true );
    }

    // Call inmediatle after the back-end services or heavy process was finished
    const hideSpinner = () => {
        setisLoading( false );
    }

    return {
        isLoading,
        showSpinner,
        hideSpinner,
        setisLoading,
        reset
    };

}